module.exports = __webpack_public_path__ + "img/midea.f81d4272.jpg";